import { SelectContactList } from "./campaign-edit/select-contact-list/select-contact-list.component";

export class Campaign {
  id: number;
  subject: string;
  type: string;
  linkShortener: boolean;
  urlParameters: boolean;
  isDiacritic: boolean;
  uploadFile: boolean;
  smsForward: boolean;
  content: string;
  mailPlainText: string;
  insAt: string;
  sendImmediately: boolean;
  sendOn: string;
  sendUntil: string;
  sendingStatus: number;
  contactLists: SelectContactList[];

  constructor(
    id?: number,
    subject?: string,
    type?: string,
    linkShortener?: boolean,
    urlParameters?: boolean,
    isDiacritic?: boolean,
    uploadFile?: boolean,
    smsForward?: boolean,
    content?: string,
    mailPlainText?: string,
    insAt?: string,
    sendImmediately?: boolean,
    sendOn?: string,
    sendUntil?: string,
    sendingStatus?: number,
    contactLists?: SelectContactList[]) {
    this.id = id ? id : 0;
    this.subject = subject ? subject : "";
    this.type = type ? type : "";
    this.linkShortener = linkShortener ? linkShortener : false;
    this.urlParameters = urlParameters ? urlParameters : false;
    this.isDiacritic = isDiacritic ? isDiacritic : false;
    this.uploadFile = uploadFile ? uploadFile : false;
    this.smsForward = smsForward ? smsForward : false;
    this.content = content ? content : "";
    this.mailPlainText = mailPlainText ? mailPlainText : "";
    this.insAt = insAt ? insAt : "";
    this.sendImmediately = sendImmediately ? sendImmediately : false;
    this.sendOn = sendOn ? sendOn : "";
    this.sendUntil = sendUntil ? sendUntil : "";
    this.sendingStatus = sendingStatus ? sendingStatus : 0;
    this.contactLists = contactLists ? contactLists : [];
  }
}
